import { useMutation } from '@tanstack/react-query';
import i18next from 'i18next';
import { useServices, useStores } from 'index';

type Callbacks = {
  onSuccess?: (data) => Promise<void> | void;
};

export const useExtractStudentsFromCSV = (callbacks?: Callbacks) => {
  const inviteStudentsService = useServices().inviteStudentsService;
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: (file: File) => !!file && inviteStudentsService.extractStudentsFromCSV(file),
    onSuccess: async (response) => {
      notificationsStore.addToast('success', i18next.t('StudentsDataUploadedSuccessfully', { ns: 'studentsPage' }), 'success');
      await callbacks?.onSuccess?.(response);
    },
    onError: () => notificationsStore.addToast('error', i18next.t('StudentsDataUploadError', { ns: 'studentsPage' }), 'error')
  });
};
